import { ButtonIcon } from 'components';
import { useSearch } from 'features/search';
import { useCallback } from 'react';
import styled from 'styled-components';

const CustomButtonIcon = styled(ButtonIcon)``;

const SearchButton = () => {
  const { searchOpened, setSearchOpened } = useSearch();

  const handleClick = useCallback(
    (e) => {
      setSearchOpened(!searchOpened);
    },
    [searchOpened]
  );

  return searchOpened ? (
    <CustomButtonIcon
      type="button"
      onClick={handleClick}
      icon={searchOpened ? 'close' : 'search'}
      width={{ m: 60, d: 80 }}
      height={{ m: 60, d: 80 }}
      bg="transparent"
      color="primary_400"
      iconWidth={20}
    />
  ) : (
    <ButtonIcon
      type="button"
      onClick={handleClick}
      icon={searchOpened ? 'close' : 'search'}
      width={{ m: 60, d: 80 }}
      height={{ m: 60, d: 80 }}
      bg="transparent"
      color="primary_400"
      iconWidth={20}
    />
  );
};

export default SearchButton;
